module.exports = __webpack_public_path__ + "static/download-background-1ca1feaf454211ae4710549216c9bd03.jpg";